import type { GlossaryId } from '~/generated/glossary.types';

export enum TagActionType {
  GAIN_HEALTH = "GAIN_HEALTH",
  LOSE_HEALTH = "LOSE_HEALTH",
  LOSE_RESILIENCE = "LOSE_RESILIENCE",
  ACQUIRE_STRAIN = "ACQUIRE_STRAIN",
  REDUCE_STRAIN = "REDUCE_STRAIN",
}

export interface TagAction {
  type: TagActionType;
  value?: number;
  sourceName?: string;
  sourceType?: "Item" | "Ability";
}

export interface Skill {
  name: string;
  glossaryId: GlossaryId;
  formula: string;
  pool: number;
}

export interface RollResult {
  id: string;
  name: string;
  hits: number;
  flatHits?: number;
  rolls: number[];
  isFumble: boolean;
  isCritFumble: boolean;
}

export interface TagNotification {
  id: string;
  type: TagActionType;
  value?: number;
  sourceName?: string;
  sourceType?: "Item" | "Ability";
}

export interface RestNotification {
  id: string;
  restType: "snack" | "meal" | "fullRest";
  resilienceGained: number;
  strainRemoved: number;
}

export type Notification =
  | { kind: "roll"; data: RollResult }
  | { kind: "tag"; data: TagNotification }
  | { kind: "rest"; data: RestNotification };

export interface ItemOrAbility {
  id: string;
  content: string;
  isEditing: boolean;
}
